import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { useAppToken } from "../../theme/v6/useAppToken";

type Props = {
  value: number;
  options: Array<{ value: number; label: string; disabled: boolean }>;
  onChange: (currencyId: number) => void;
};

const SummaryCurrencySelect = (props: Props) => {
  const { t } = useTranslation("translations");
  const { token } = useAppToken();

  return (
    <Select
      {...props}
      aria-label={t("currency")}
      size="small"
      variant="borderless"
      popupMatchSelectWidth={100}
      styles={{
        root: {
          width: 60,
          height: 20,
          flexShrink: 0,
          paddingInline: 0,
          paddingBlock: 0,
          alignItems: "center",
          fontSize: token.fontSizeSM,
          lineHeight: 1.5,
        },
        content: { marginInlineEnd: 2 },
        suffix: { fontSize: 10 },
      }}
    />
  );
};

export default SummaryCurrencySelect;
